import { store } from '~/store/configureStore';
import { TRootState } from '~/store/types';

export const UserUtils = {
  isParentOffice: () => {
    const {
      childOffices,
      selectedChildOffice,
      user: currentLoggedUser,
    } = (store.getState() as TRootState).user;

    const hasMultipleChildOffice = childOffices?.length > 0;
    const isSelectedOfficeSameWithLoggedUser = selectedChildOffice?.id === currentLoggedUser?.id;

    return hasMultipleChildOffice && isSelectedOfficeSameWithLoggedUser;
  },
};
